import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SignGroup, SigningStatus } from "@models/annual-statements/annual-statement-enums";
import { ApproverStatus } from "@models/documents/approver-status.enum";
import { SignatureStatus } from "@models/documents/signature-status.enum";
import { SignRow } from "@models/documents/sign-documents";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<SignRow> & {
  editInfo:  (data: unknown, sendEmail: boolean) => void,
  delete: ActionEvent,
  resend: ActionEvent,
};

@Component({
  selector: 'app-ag-annual-sign-actions',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    AgActionIconButtonComponent
  ],
  templateUrl: 'ag-annual-sign-actions.component.html',
  styleUrl: 'ag-annual-sign-actions.component.scss'
})
export class AgAnnualSignActionsComponent implements ICellRendererAngularComp {
  protected params!: CellRendererParams;
  protected rowIndex: number | undefined;
  protected type: SignGroup | undefined;
  protected disabled = false;
  protected status: ApproverStatus | SigningStatus | SignatureStatus | undefined;
  protected menuActions = [
    {
      name: 'Delete',
      iconClass: 'icon ic-trash-16 mr-1',
      isVisible: () => this.isDeleteActionVisible(),
      action: () => this.delete()
    },
    {
      name: 'Re-send',
      iconClass: 'icon ic-send-16 mr-1',
      isVisible: () => this.isResendActionVisible(),
      action: () => this.resend()
    },
    {
      name: 'Change sending info',
      iconClass: 'icon ic-send-16 mr-1',
      isVisible: () => this.isChangeSendingInfoActionVisible(),
      action: () => this.editInfo()
    },
  ];

  viewMenuActions = this.menuActions;

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.type = params.data?.type;
    this.status = params.data?.status;
    this.disabled = params.data?.disabled ?? false;

    if (this.params.node.rowIndex !== null && this.params.node.rowIndex !== undefined) {
      this.rowIndex = this.params.node.rowIndex;
    }

    this.updateMenuActions();
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.updateMenuActions();
    return true;
  }

  updateMenuActions(): void {
    this.viewMenuActions = this.menuActions.filter(x => x.isVisible());
  }

  isDeleteActionVisible(): boolean {
    return (this.type === SignGroup.Approver && this.status === ApproverStatus.Created)
      || (this.type == SignGroup.CarbonCopy && this.status != SigningStatus.Signed);
  }

  isResendActionVisible(): boolean {
    return (this.type === SignGroup.Signatories && this.status === SigningStatus.Sent)
      || (this.type === SignGroup.Approver && this.status === ApproverStatus.WaitingForApproval);
  }

  isChangeSendingInfoActionVisible(): boolean {
    return (this.type === SignGroup.Signatories && this.status == SignatureStatus.WaitingForSending);
  }

  delete(): void {
    this.params.delete(this.rowIndex);
  }

  resend(): void {
    this.params.resend(this.rowIndex);
  }

  editInfo(): void {
    this.params.editInfo(this.rowIndex, false);
  }
}
